import type { WidgetElementsBookingElementButtonStyles } from "@/elements/widget/elements/booking-element/button/styles/widget-elements-booking-element-button-styles";

/**
 * We expect all user-provided styles to be applied via safe DOM "sinks",
 * (e.g., Lit's `styleMap`), which largely eliminates the risk of XSS.
 *
 * However, there are a small number of syntactically valid CSS values that
 * can still trigger network requests, or invoke browser-specific legacy
 * behaviors.
 *
 * While it doesn't appear that these type of values can realistically be
 * used to exploit modern browsers, we'll strip them out of the styles as
 * an additional precaution.
 *
 * @see {@link https://cheatsheetseries.owasp.org/cheatsheets/Cross_Site_Scripting_Prevention_Cheat_Sheet.html#safe-sinks}
 * @see {@link https://lit.dev/docs/templates/directives/#stylemap}
 */
export const sanitizeWidgetElementsBookingElementButtonStyles = (
  styles: WidgetElementsBookingElementButtonStyles,
): WidgetElementsBookingElementButtonStyles => {
  const sanitizedStyles = { ...styles };

  for (const [key, value] of Object.entries(styles) as [
    keyof WidgetElementsBookingElementButtonStyles,
    WidgetElementsBookingElementButtonStyles[keyof WidgetElementsBookingElementButtonStyles],
  ][]) {
    if (value && /url\s*\(|expression|@import|</i.test(value)) {
      sanitizedStyles[key] = "";
    }
  }

  return sanitizedStyles;
};
